import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import LogoImg from '../assets/img/logo.svg'


const Header = () => {

    const handleMenuOpen = () => document.body.classList.add('menu_open');
    const handleMenuClose = () => document.body.classList.remove('menu_open');

    return(
        <header>
            <i className="fa fa-bars menu_icon" onClick={handleMenuOpen} />
            <div className="d-flex justify-content-between top_header">
                <div>
                    <a href="tel: +919654377137"><i className="fa fa-mobile" /> +91 9654 377 137</a>
                </div>
                <div>
                    <a href="mailto: sales@travelcore.co.in"><i className="fa fa-envelope" /> sales@travelcore.co.in</a>
                </div>
            </div>


            <div className="main_header">
                <div className="main_logo">
                    <Link to="/">
                        <img src={LogoImg} alt="Travelcore" />
                        <h6>TravelCore</h6>
                    </Link>
                </div>
                <div className="main_menu">
                    <i className="fa fa-times cm_close_menu" onClick={handleMenuClose} />
                    <ul>
                        <li><NavLink onClick={handleMenuClose} exact to="/">Home</NavLink></li>
                        <li><NavLink onClick={handleMenuClose} exact to="/about">About Us</NavLink></li>
                        <li><NavLink onClick={handleMenuClose} exact to="/locations">Locations</NavLink></li>
                        <li><NavLink onClick={handleMenuClose} exact to="/hotels">Hotels</NavLink></li>
                        <li>
                            <Dropdown>
                                <Dropdown.Toggle variant="success">
                                Services
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="javascript:void(0);"><NavLink onClick={handleMenuClose} exact to="/mice">Mice</NavLink></Dropdown.Item>
                                    <Dropdown.Item href="javascript:void(0);"><NavLink onClick={handleMenuClose} exact to="/payment-partner">Payment Partner</NavLink></Dropdown.Item>
                                    <Dropdown.Item href="javascript:void(0);"><NavLink onClick={handleMenuClose} exact to="/cab-service">Cab service</NavLink></Dropdown.Item>
                                    <Dropdown.Item href="javascript:void(0);"><NavLink onClick={handleMenuClose} exact to="/flight-service">Flight service</NavLink></Dropdown.Item>
                                    {/* <Dropdown.Item href="javascript:void(0);"><NavLink onClick={handleMenuClose} exact to="/train-service">Train service</NavLink></Dropdown.Item> */}
                                </Dropdown.Menu>
                            </Dropdown>
                        </li>
                        <li><NavLink onClick={handleMenuClose} exact to="/contact">Contact Us</NavLink></li>
                    </ul>
                </div>
            </div>


        </header>
    )
}

export default Header;